import { TokenHistoryLabel } from "kadow-jetpack-model";

export default function sortCTAByPriority(
  ctas: TokenHistoryLabel[],
  priorityOrder: TokenHistoryLabel[]
): TokenHistoryLabel[] {
  const prioritySet = new Set(priorityOrder);
  const existingPriority = priorityOrder.filter((item) => ctas.includes(item));
  const remaining = ctas.filter(
    (value) => !prioritySet.has(value as TokenHistoryLabel)
  );

  return [...existingPriority, ...remaining];
}
